import { FC, ReactNode } from 'react';
import ReactDOM from 'react-dom';
import { CloseButton, ModalContent, Overlay } from './styles';
import { IconButton } from '../buttons/iconButtons/iconButton';
import closeIcon from 'assets/icons/close-icon-white.svg';
import { useModal } from 'shared/lib/modal';

interface ModalProps {
	children: ReactNode;
	showCloseButton?: boolean;
	onClose?: () => void;
	id?: string;
	zIndex?: number;
	scrollable?: boolean | string;
}

export const Modal: FC<ModalProps> = ({
	children,
	showCloseButton = false,
	scrollable = 'false',
	onClose,
	id,
	zIndex,
}) => {
	const { isOpen, closeModal } = useModal();

	const modalRoot = document.getElementById('modal-root');

	if (!modalRoot) {
		console.error('Modal root not found');
		return null;
	}

	return ReactDOM.createPortal(
		<Overlay $isOpen={isOpen} onClick={onClose} id={id} $zIndex={zIndex} $scrollable={scrollable}>
			{showCloseButton && (
				<CloseButton>
					<IconButton
						role="close-button"
						iconSrc={closeIcon}
						styles={{ iconHeight: '16px' }}
						disableTouch
						onClick={closeModal}
					/>
				</CloseButton>
			)}
			{isOpen ? <ModalContent onClick={event => event.stopPropagation()}>{children}</ModalContent> : <></>}
		</Overlay>,
		modalRoot,
	);
};
